<template>
  <div class="container">
    <!-- <form
      id="myForm"
      action="/cc-onboard/webform/apply/request?cc=C2"
      method="post"
      @submit.prevent="submitForm"
    >
      <label for="username">Username:</label>
      <input type="text" id="name" name="name" v-model="formData.name" />

      <label for="password">Password:</label>
      <input type="password" id="email" name="email" v-model="formData.email" />

      <button type="submit">Submit</button>
    </form> -->
    <button style="height: 50px; width: 100px" @click="apiTest"></button>

    <!-- <form
      id="myForm"
      action="/cc-onboard/webform/apply/request"
      method="post"
      @submit.prevent="submitForm"
    >
      <button type="submit">Submit2</button>
    </form> -->
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import MasterService from "@/service/restfulService/CCOnboardMasterService";
import Apis from "@/service/restfulService/Apis";

interface FormData {
  name: string;
  email: string;
}

const formData = ref<FormData>({
  name: "max",
  email: "ffd@gfg.com",
});

const form = ref<HTMLFormElement | null>(null);

const apiTest = () => {
  // MasterService.apiTest().then((res) => {
  //   console.log(res);
  //   if ((res.status = 302)) {
  //     console.log(res);
  //     // window.open(res.headers)
  //   }
  // });

  fetch(`${Apis.FULL_URL}/cc/backend-route`, {
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => {
    if (response.redirected) {
      console.log(response);
      // window.location.href = response.url;
    }
  });
};

const submitForm = () => {
  console.log(formData.value); // Log the hardcoded data
  const url =
    "http://localhost:5174/cc-onboard/webform/apply/request?type=bundling&name=" +
    encodeURIComponent(formData.value.name) +
    "&email=" +
    encodeURIComponent(formData.value.email);
  window.open(url, "_blank");
};
</script>
